import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail, ArrowRight } from 'lucide-react';
export function GetOfferPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-247">
      <Header data-id="element-248" />

      <section className="w-full bg-gray-50 py-32 px-6 lg:px-8 relative min-h-[80vh] flex items-center" data-id="element-249">
        {/* Geometric accent */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-white -skew-x-12 transform translate-x-1/3 pointer-events-none" data-id="element-250" />

        <div className="max-w-7xl mx-auto relative z-10 w-full" data-id="element-251">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-252">
            <div data-id="element-253">
              <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-254">
                <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-255">
                  Fast & Fair Offers
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-black text-black mb-8 tracking-tighter leading-none" data-id="element-256">
                GET YOUR <br data-id="element-257" />
                <span className="text-slate-600" data-id="element-258">CASH OFFER</span> <br data-id="element-259" />
                TODAY.
              </h1>

              <p className="text-xl font-medium text-gray-700 mb-12 max-w-md" data-id="element-260">
                Ready to sell? Reach out directly and we'll provide a fair,
                no-obligation cash offer for your property within 24 hours.
              </p>

              <div className="space-y-6" data-id="element-261">
                <div className="flex items-center gap-4" data-id="element-262">
                  <div className="w-12 h-12 bg-black flex items-center justify-center text-white font-bold text-xl" data-id="element-263">
                    1
                  </div>
                  <p className="text-lg font-bold text-black" data-id="element-264">
                    Contact us via phone or email
                  </p>
                </div>
                <div className="flex items-center gap-4" data-id="element-265">
                  <div className="w-12 h-12 bg-black flex items-center justify-center text-white font-bold text-xl" data-id="element-266">
                    2
                  </div>
                  <p className="text-lg font-bold text-black" data-id="element-267">
                    We analyze your property value
                  </p>
                </div>
                <div className="flex items-center gap-4" data-id="element-268">
                  <div className="w-12 h-12 bg-slate-600 flex items-center justify-center text-white font-bold text-xl" data-id="element-269">
                    3
                  </div>
                  <p className="text-lg font-bold text-black" data-id="element-270">
                    Get your cash offer instantly
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6" data-id="element-271">
              <a href="tel:630-686-7233" className="group flex items-center gap-6 p-8 bg-white border-2 border-gray-200 hover:border-slate-600 hover:shadow-2xl transition-all duration-300" data-id="element-272">
                <div className="w-20 h-20 bg-slate-600 flex items-center justify-center text-white shrink-0 group-hover:bg-black transition-colors" data-id="element-273">
                  <Phone className="w-10 h-10" data-id="element-274" />
                </div>
                <div className="flex-1" data-id="element-275">
                  <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-276">
                    Call Us Now
                  </p>
                  <p className="text-3xl font-black text-black group-hover:text-slate-600 transition-colors mb-2" data-id="element-277">
                    630-686-7233
                  </p>
                  <p className="text-sm text-gray-600 font-medium" data-id="element-278">
                    Speak with our team directly
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-slate-600 group-hover:translate-x-2 transition-transform" data-id="element-279" />
              </a>

              <a href="mailto:ravenadvisorsllc@gmail.com" className="group flex items-center gap-6 p-8 bg-white border-2 border-gray-200 hover:border-slate-600 hover:shadow-2xl transition-all duration-300" data-id="element-280">
                <div className="w-20 h-20 bg-black flex items-center justify-center text-white shrink-0 group-hover:bg-slate-600 transition-colors" data-id="element-281">
                  <Mail className="w-10 h-10" data-id="element-282" />
                </div>
                <div className="flex-1" data-id="element-283">
                  <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-284">
                    Email Us
                  </p>
                  <p className="text-2xl font-black text-black group-hover:text-slate-600 transition-colors mb-2 break-all" data-id="element-285">
                    ravenadvisorsllc@gmail.com
                  </p>
                  <p className="text-sm text-gray-600 font-medium" data-id="element-286">
                    Get a response within hours
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-slate-600 group-hover:translate-x-2 transition-transform" data-id="element-287" />
              </a>

              <div className="bg-black p-6 text-white" data-id="element-288">
                <p className="text-sm font-bold uppercase tracking-wider text-slate-400 mb-2" data-id="element-289">
                  Why Choose Us?
                </p>
                <p className="text-lg font-medium" data-id="element-290">
                  No fees, no commissions, no hassle. Just a fair cash offer and
                  a fast closing on your timeline.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-291" />
    </div>;
}